__turbopack_context__.v({
  "icon": "WOzh4a_icon",
});
